export default {
  data: [
    {
      id: 1,
      name: "Tratamento 1",
      created: "2/4/2020",
      updated: "5/7/2019"
    },
    {
      id: 2,
      name: "Tratamento 2",
      created: "10/28/2019",
      updated: "4/11/2019"
    },
    {
      id: 3,
      name: "Tratamento 3",
      created: "9/22/2019",
      updated: "2/3/2020"
    },
    {
      id: 4,
      name: "Tratamento 4",
      created: "6/8/2019",
      updated: "5/29/2019"
    },
    {
      id: 5,
      name: "Tratamento 5",
      created: "8/2/2019",
      updated: "3/18/2019"
    }
  ]
};
